import { render, staticRenderFns } from "./SnoozeItem.vue?vue&type=template&id=7e1488b3&scoped=true&"
import script from "./SnoozeItem.vue?vue&type=script&lang=ts&"
export * from "./SnoozeItem.vue?vue&type=script&lang=ts&"
import style0 from "./SnoozeItem.vue?vue&type=style&index=0&id=7e1488b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1488b3",
  null
  
)

export default component.exports